import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const DrugsAndDyes = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Drugs and dyes"
    videos={[
      "https://www.youtube.com/embed/Yd4Gto1Uzfc",
      "https://www.youtube.com/embed/249FNCSR-Cw",
      "https://www.youtube.com/embed/I5EMDuyKp3w",
      "https://www.youtube.com/embed/bTBNabnUHzQ",
    ]}
    takeaways={[
      { text: "Learn synthesis of paracetamol and aspirin." },
      { text: "Learn synthesis of Indigotin." },
      { text: "Preparation of methyl orange is imp." },
    ]}
    questions={[
      "Propose the synthesis and mechanism for the acetylsalicylic acid.",
      "Write the synthesis of a dye which is used as an indicator in the neutralization of acid-base titrations.",
      "Write down the detailed synthetic route and the reaction mechanism of an analgesic which can be readily absorbed in the gastrointestinal tract. Detailed synthetic route and reaction mechanism of Paracetamol."
    ]}
    exampleVideos={[]}
  />
);
}

export default DrugsAndDyes;
